import React, { useEffect } from 'react';
import { Button, TopActionBar, ModuleBridge } from '../components';
import { DOC_TYPES } from '../constants/docLinks';

export const BackupApplianceSetup = () => {
    useEffect(() => {
        return () => {
            if (window?.clearAllIntervals) {
                window?.clearAllIntervals();
            }
        };
    }, []);

    return (
        <>
            <TopActionBar showDocumentationLinksDropdown={true} documentationType={DOC_TYPES.MIGRATION}>
                <div>
                    <Button
                        type="primary"
                        className="button button--primary"
                        onClick={() => window.setupBackupAppliance()}
                    >
                        Setup New Backup Appliance
                    </Button>
                </div>
            </TopActionBar>
            <div id="backup_appliances_setup_container"></div>
            <ModuleBridge moduleId="backup_appliances_setup_module" />
        </>
    );
};
